import { Card } from './ui/card';

/** Плитка показателя под шапкой раздела: «Клиенты», «Жалобы», «Пропущенные». */
const StatCard = ({ panelId, title, value }) => (
  <Card data-panel-id={panelId} className="p-3">
    <div className="text-xs font-medium text-muted-foreground">{title}</div>
    <div className="mt-1 text-lg font-bold">{value}</div>
  </Card>
);

export default StatCard;
